import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { courses as mockCourses } from '../data/mockData';
import '../styles/CourseDetail.css';

const CourseDetail = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  useEffect(() => {
    const found = mockCourses.find((c) => c._id === courseId);
    if (found) {
      setCourse(found);
      setError(null);
    } else {
      setError('아카이브 항목을 찾을 수 없습니다.');
    }
    setLoading(false);
  }, [courseId]);

  if (loading) {
    return (
      <div className="course-detail-container">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>불러오는 중...</p>
        </div>
      </div>
    );
  }

  if (error || !course) {
    return (
      <div className="course-detail-container">
        <div className="error-container">
          <p>{error || '항목이 없습니다.'}</p>
          <button onClick={() => navigate('/courses')} className="btn btn-primary">
            아카이브로
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="course-detail-container service-detail">
      <div className="course-header">
        <div className="course-header-content">
          <div className="course-info">
            <div className="course-category-badge">{course.category} · 아카이브</div>
            <h1>{course.title}</h1>
            <p className="course-description">{course.description}</p>
            <div className="course-meta">
              <div className="meta-item"><span>구성: {course.instructor.name}</span></div>
              <div className="meta-item"><span>난이도: {course.level}</span></div>
              <div className="meta-item"><span>기간: {course.duration}</span></div>
            </div>
          </div>

          <div className="course-action-card archive-action-card">
            <div className="course-price">
              <span className="paused-label">신규 결제 불가</span>
              <span className="paused-price">₩{course.price.toLocaleString()}</span>
            </div>
            <button
              type="button"
              className="btn btn-primary btn-block"
              onClick={() => setShowPaymentModal(true)}
            >
              결제 안내 보기
            </button>
            <p className="archive-action-note">
              강의 판매·수강 신청은 중단되었습니다. 요강·전형 정보는 가이드와 루트 파인더를 이용해 주세요.
            </p>
            <div className="archive-action-links">
              <Link to="/guides">가이드</Link>
              <Link to="/finder">루트 찾기</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="course-instructor-section">
        <h2>운영자</h2>
        <div className="instructor-profile">
          <div className="instructor-avatar">
            <img
              src="/images/instructor-profile-front.png"
              alt={course.instructor.name}
            />
          </div>
          <div className="instructor-info">
            <h3>{course.instructor.name}</h3>
            <p className="instructor-title">입시 루트·요강 해설</p>
            <p className="instructor-bio">
              {course.instructor.bio || '미라이쥬쿠에서 일본 입시 정보를 정리합니다.'}
            </p>
          </div>
        </div>
      </div>

      {showPaymentModal && (
        <div className="payment-modal-overlay" role="dialog" aria-modal="true">
          <div className="payment-modal payment-modal-paused">
            <div className="payment-modal-header">
              <h3>결제·수강 안내</h3>
              <button type="button" onClick={() => setShowPaymentModal(false)} className="close-btn" aria-label="닫기">
                &times;
              </button>
            </div>
            <div className="payment-modal-content">
              <div className="course-summary">
                <h4>{course.title}</h4>
                <p className="price">판매 중단</p>
              </div>
              <p className="payment-paused-copy">
                카드 결제 창과 신규 수강 등록은 운영하지 않습니다.
                사이트는 일본 대학 입시 요강·전형 정보 제공으로 전환되었습니다.
              </p>
              <ul className="payment-paused-list">
                <li>신규 결제: 불가</li>
                <li>이전 수강 기록: 마이페이지에서 조회</li>
                <li>문의: 정보 오류 제보만 접수</li>
              </ul>
              <div className="payment-paused-actions">
                <Link to="/guides" className="btn btn-primary btn-block" onClick={() => setShowPaymentModal(false)}>
                  가이드로 이동
                </Link>
                <button type="button" className="btn btn-outline btn-block" onClick={() => setShowPaymentModal(false)}>
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CourseDetail;
